module.exports = __webpack_public_path__ + "static/img/wanglili.c8cdd153.png";